<template>
    <div class="modal-wrapper" @click="close">
		<div class="modal-container modal-container-mini" @click.stop.prevent="() => false">
			<div class="modal-header">
				<div class="row">
					<div class="col-xs-12 col-lg-12">
						INFORMAR FILIAL DE ENVIO
						<button class="modal-close" @click="close"><i class="fa fa-times"></i></button>
					</div>
				</div>
			</div>
			<div class="modal-body modal-body-mini">
                <div class="row">
                    <div class="col-xs-12">
                        <p>Há mais de uma filial entre os pedidos selecionados para montagem da roteirização. Selecione a filial que deseja sincronizar a Carga Externa.</p>
                    </div>
                    <div class="col-xs-12">
                        <FormSelect v-model="form.select" label="Filial" :options="options" :required="true" tooltip="Informe a filial, no seu Sistema Atak, para qual vai enviar a carga" ref="company_branch" />
                    </div>
                </div>
            </div>
			<div class="modal-footer">
                <div class="row">
                    <div class="col-xs-6">
                        <button class="modal-button-close" @click="close" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-times'"></i> CANCELAR
                        </button>
                    </div>
                    <div class="col-xs-6">
                        <button class="modal-button-save" :disabled="loading" @click="confirm">
                            CONTINUAR <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-caret-right'"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormSelect from '../../components/FormSelect.vue'
    
    export default {
        name: "RoutingModalCompanyBranches",

        props: {
            list_company_branches: {
                type: Array,
                require: true,
            },
            company_branch: {
                type: String,
                require: false,
                default: "",
            }
        },

        components: { 
            FormSelect,
        },

        data: function() {
            return {
                loading: false,
                form: {
                    select: this.company_branch,
                },
                options: this.getOptions(),
            }
        },

        methods: {
            getOptions: function() {
                let company_branch = {};
                this.list_company_branches.map(item => {
                    company_branch[item] = item;
                });
                return company_branch;
            },

            confirm: function() {
                // Envia das informações e fecha o modal
                if (this.form.select)
                    this.$emit("confirm", this.form.select);
                else
                    this.$refs.company_branch.validate();
            },

            // Fecha o modal
            close: function() {
                this.$emit("close");
            },
        }
    }
</script>

<style scoped>
.modal-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: #00000044;
	z-index: 3;
}

.modal-container {
	position: absolute;
	margin: auto;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	border-radius: 4px;
}

.modal-container-mini {
	width: 600px;
	height: 340px;
}

.modal-header {
	position: relative;
	border-bottom: 1px solid #ddd;
	min-height: 50px;
	padding: 15px;
	font-weight: bold;
	background: #f9f9f9;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.modal-close {
	position: absolute;
	top: 12px;
	right: 15px;
	font-size: 20px;
	background: none;
	border: none;
	color: #999;
}

.modal-body {
	padding: 15px;
	width: 100%;
	overflow-y: auto;
}

.modal-body-mini {
	height: 230px;
}

.modal-footer {
	position: absolute;
	bottom: 0;
	height: 61px;
	padding: 15px;
	width: 100%;
	border-top: 1px solid #ddd;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	overflow-x: hidden;
	overflow-y: auto;
}

.modal-button-close {
	background: #222;
	border: 2px solid #222;
	color: #fff;
	width: 120px;
	height: 30px;
	font-size: 12px;
	font-weight: bold;
    margin-right: 15px;
}

.modal-button-back {
	background: #fff;
	border: 2px solid #222;
	color: #222;
	width: 120px;
	height: 30px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-save {
	float: right;
	background: #0a600a;
	color: #fff;
	border: none;
	width: 120px;
	height: 30px;
	line-height: 25px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-research {
	float: right;
    margin-right: 15px;
	background: #fff;
	border: 2px solid #222 !important;
    color: #222;
	border: none;
	width: 120px;
	height: 30px;
	line-height: 25px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-save:disabled,
.modal-button-research:disabled,
.modal-button-back:disabled,
.modal-button-close:disabled {
	cursor: not-allowed;
	opacity: 0.4;
}

.loading {
    position: absolute;
    top: 50px;
    left: 0;
    background: rgba(255,255,255,.7);
    color: #222;
    text-align: center;
    font-family: Verdana;
    z-index: 10;
}

.loading-mini {
    width: 600px;
    height: 229px;
    line-height: 229px;
}

.loading-icon, 
.loading-percent {
    border-top: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #f5f5f5;
    padding: 20px 5px 20px 20px;
    font-size: 20px;
    z-index: 10;
}

.loading-text {
    border-top: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background-color: #f5f5f5;
    padding: 20px 20px 20px 5px;
    font-size: 20px;
    z-index: 10;
}

.error {
    color: red;
}

.success {
    color: green;
}

.gray {
    color: #ddd;
}
</style>